export const MAP_CACHE_TTL_DAYS = 30;
const MAP_CACHE_TTL_MS = MAP_CACHE_TTL_DAYS * 24 * 60 * 60 * 1000;
const TOUCH_THROTTLE_MS = 5 * 60 * 1000;
const RANGE_CACHE_LAST_USED_HEADER = "x-trekkin-last-used";

export const PMTILES_CACHE = "trekkin-remote-pmtiles-ranges-v1";
export const RASTER_TILE_CACHE = "trekkin-remote-raster-tiles-v1";

const PMTILES_LAST_USED_KEY = "trekkin_pmtiles_last_used";

const lastTouch = {
  pmtiles: 0,
};

const getKey = () => PMTILES_LAST_USED_KEY;

export function touchMapCache() {
  try {
    const now = Date.now();
    if (now - lastTouch.pmtiles < TOUCH_THROTTLE_MS) return;
    lastTouch.pmtiles = now;
    localStorage.setItem(getKey(), String(now));
  } catch {}
}

export function readMapCacheLastUsed() {
  try {
    const raw = localStorage.getItem(getKey());
    const ts = raw ? Number(raw) : 0;
    return Number.isFinite(ts) ? ts : 0;
  } catch {
    return 0;
  }
}

export async function purgeExpiredMapCache() {
  if (typeof caches === "undefined") return;
  try {
    const cache = await caches.open(PMTILES_CACHE);
    const requests = await cache.keys();
    const cutoff = Date.now() - MAP_CACHE_TTL_MS;
    await Promise.all(
      requests.map(async (request) => {
        try {
          const response = await cache.match(request);
          const lastUsed = Number(
            response?.headers?.get(RANGE_CACHE_LAST_USED_HEADER) ||
              response?.headers?.get("x-trekkin-cached-at") ||
              0
          );
          if (Number.isFinite(lastUsed) && lastUsed > 0 && lastUsed < cutoff) {
            await cache.delete(request);
          }
        } catch {}
      })
    );
  } catch {}

  const lastUsed = readMapCacheLastUsed();
  if (!lastUsed) return;
  if (Date.now() - lastUsed <= MAP_CACHE_TTL_MS) return;
  await Promise.all([
    caches.delete(PMTILES_CACHE),
    caches.delete(RASTER_TILE_CACHE),
  ]);
  try {
    localStorage.removeItem(getKey());
  } catch {}
}

export async function purgeExpiredMapCaches() {
  await purgeExpiredMapCache();
}

export async function clearMapCaches() {
  if (typeof caches === "undefined") return { deleted: [], totalDeleted: 0 };
  const names = await caches.keys();
  const deleted = [];
  const mapCacheMatchers = [
    /^pmtiles$/i,
    /pmtiles/i,
    /maplibre/i,
    /trekkin.*map/i,
    /tiles/i,
  ];
  for (const name of names) {
    const shouldDelete =
      name === PMTILES_CACHE || mapCacheMatchers.some((rx) => rx.test(String(name)));
    if (!shouldDelete) continue;
    const ok = await caches.delete(name);
    if (ok) deleted.push(name);
  }
  try {
    localStorage.removeItem(PMTILES_LAST_USED_KEY);
  } catch {}
  return { deleted, totalDeleted: deleted.length };
}

export const MAP_CACHE_TTL_INFO = `${MAP_CACHE_TTL_DAYS} dias`;
export { RANGE_CACHE_LAST_USED_HEADER };
